module.exports = __webpack_public_path__ + "img/aboutQCS.bb8f2afd.jpg";